import { IframeIcon } from '@/components/tiptap-editor/tiptap-icons/iframe-icon';
import { isSelectionTopNode } from '@/lib/zy-tiptap-utils';
import { forwardRef } from 'react';
import { GenericExtensionButton, type GenericExtensionButtonProps } from '../generic-extension-button';

export const IframeButton = forwardRef<
    HTMLButtonElement,
    Omit<GenericExtensionButtonProps, 'extensionName' | 'extensionType' | 'icon' | 'label' | 'command'>
>((props, ref) => (
    <GenericExtensionButton
        extensionName="iframe"
        extensionType="node"
        icon={IframeIcon}
        isDisabled={editor => !isSelectionTopNode(editor)}
        label="Insert iframe"
        command={editor => editor.commands.insertIframe({})}
        ref={ref}
        {...props}
    />
));

IframeButton.displayName = 'IframeButton';

export default IframeButton;
